import { formatDate } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { EventEmitter, Injectable } from '@angular/core';
import * as _ from 'lodash';
import * as moment from 'moment';
import { Observable, Subject } from 'rxjs';
import { AttendanceCode } from '../../classroom360/attendance/models/attendance-code.model';
import { DisciplineReferral } from '../../classroom360/discipline-referral/discipline-referral.model';
import { BehaviorSharedService } from '../../shared-components/behavior/behavior-shared.service';
import { CustomField } from '../../shared-components/custom-page/models/custom-field.model';
import { EFormTemplate } from '../../shared-components/e-forms/e-form-template.model';
import { Lookup } from '../../shared-components/lookup/lookup.model';
import { ScheduleCalendar } from '../../shared-components/models/schedule-calendar.model';
import { SharedService } from '../../shared-components/shared.service';
import { System } from '../../shared-components/System';
import { GeneralPreferences } from '../../shared-components/user-preferences/general-preferences.model';
import { UserPreferencesService } from '../../shared-components/user-preferences/user-preferences.service';
import { UserService } from '../../shared-components/user/user.service';
import { School } from '../../shared-components/year/school.model';
import { YearService } from '../../shared-components/year/year.service';
import { CommunicationLog } from '../../shared-modules/communication-log/models/communication-log.model';
import { ReportingService } from '../../shared-modules/reporting/reporting.service';
import { StudentAttachment } from '../../shared-modules/student-attachment/student-attachment.model';
import { BehaviorEventsFilterParam } from './behavior-events/behavior-events-filter-param';
import { BehaviorInterventionsFilterParam } from './behavior-interventions/behavior-interventions-filter-param';
import { BehaviorActionCode } from './models/behavior-action-code.model';
import { BehaviorAction } from './models/behavior-action.model';
import { BehaviorAttachment } from './models/behavior-attachment.model';
import { BehaviorEvent } from './models/behavior-event.model';
import { BehaviorIncidentLetter } from './models/behavior-incident-letter.model';
import { BehaviorIncidentSearch } from './models/behavior-incident-search.model';
import { BehaviorIncident } from './models/behavior-incident.model';
import { AssociateInterventionPopup, BehaviorIntervention, Contract, CounselorStudentMeetingInterventions, DisciplineEventIntervention, InterventionAttachment, InterventionMeeting } from './models/behavior-intervention.model';
import { BehaviorLetter, GenerateMailingLabels, BehaviorLetterEmailAddress } from './models/behavior-letter.model';
import { BehaviorPolicies } from './models/behavior-policies.model';
import { BehaviorStudent } from './models/behavior-student.model';

@Injectable()
export class BehaviorService {
    isAttachmentDeleteInEventTab = false;
    addEditSchools: School[] = [];
    viewOnlySchools: School[] = [];
    quickAddSchools: School[] = [];

    behaviorLetterTemplates: EFormTemplate[] = [];

    attachmentsComponent: any;
    private _behaviorEvent: BehaviorEvent;
    public get behaviorEvent(): BehaviorEvent {
        return this._behaviorEvent;
    }

    public set behaviorEvent(value: BehaviorEvent) {
        this._behaviorEvent = value;
        this.observableBehaviorEvent.next(value);
    }

    public observableBehaviorEvent = new Subject<BehaviorEvent>();
    observableBehaviorEventStream$ = this.observableBehaviorEvent.asObservable();

    eventComments: Lookup[] = [];

    get locations(): Lookup[] {
        if (this.behaviorSharedService.locations == null) {
            return [];
        } else {
            return this.behaviorSharedService.locations;
        }
    }

    set locations(locations: Lookup[]) {
        this.behaviorSharedService.locations = locations;
    }

    get incidentCodes(): Lookup[] {
        if (this.behaviorSharedService.incidentCodes == null) {
            return [];
        } else {
            return this.behaviorSharedService.incidentCodes;
        }
    }

    set incidentCodes(codes: Lookup[]) {
        this.behaviorSharedService.incidentCodes = codes;
    }

    get contextCodes(): Lookup[] {
        if (this.behaviorSharedService.contextCodes == null) {
            return [];
        } else {
            return this.behaviorSharedService.contextCodes;
        }
    }

    set contextCodes(codes: Lookup[]) {
        this.behaviorSharedService.contextCodes = codes;
    }

    get reportedByCodes(): Lookup[] {
        if (this.behaviorSharedService.reportedByCodes == null) {
            return [];
        } else {
            return this.behaviorSharedService.reportedByCodes;
        }
    }

    set reportedByCodes(codes: Lookup[]) {
        this.behaviorSharedService.reportedByCodes = codes;
    }

    quickAddAttachments: BehaviorAttachment[] = [];
    quickAddAction: BehaviorAction;
    quickAddStudents: BehaviorStudent[] = [];
    quickAdd: Boolean;
    quickAddAFEvent: CustomField[] = [];
    quickAddAFIncident: CustomField[] = [];
    quickAddAFAction: CustomField[] = [];
    quickAddComment: string;

    studentSchedule: BehaviorAction[] = [];
    studentTeamSchedule: BehaviorAction[] = [];
    scheduleFromDate: Date;
    scheduleToDate: Date;

    actionCodes: BehaviorActionCode[] = [];
    genderOptions: Lookup[] = [];
    raceOptions: Lookup[] = [];
    notificationCodes: Lookup[] = [];
    hearingTypeCodes: Lookup[] = [];
    modifiedCodes: Lookup[] = [];
    weaponTypes: Lookup[] = [];
    finalSanctions: Lookup[] = [];
    parentNotificationCodes: Lookup[] = [];
    maxAttachmentSize = 0;
    victimTypes: Lookup[] = [];
    victimInjury: Lookup[] = [];
    TimeCodes: Lookup[] = [];
    DrugCodes: Lookup[] = [];

    _filterParam: BehaviorEventsFilterParam;
    filterChange = new EventEmitter<any>();
    generalPreferences: GeneralPreferences;
    behaviorUniqueStudents: BehaviorStudent;

    set filterParam(filterParam: BehaviorEventsFilterParam) {
        this._filterParam = filterParam;
        this.filterChange.emit();
    }

    get filterParam() {
        return this._filterParam;
    }
    createFromSaveClick = false;
    formIsDirty = false;
    // Intervention
    private _behaviorIntervention: BehaviorIntervention;
    interventionReasons: Lookup[] = [];
    interventionists: Lookup[] = [];
    interventionReferrers: Lookup[] = [];
    interventionAdministrators: Lookup[] = [];
    contractIssued: Lookup[] = [];
    contractCategories: Lookup[] = [];
    informOthers: Lookup[] = [];
    interventionStatus: Lookup[] = [];
    gangStatus: Lookup[] = [];
    interventionName: Lookup[] = [];
    addEditInterventionSchools: School[] = [];
    interventionHeaderText: string;
    parameters = [];
    param = [];

    public get behaviorIntervention(): BehaviorIntervention {
        return this._behaviorIntervention;
    }

    public set behaviorIntervention(value: BehaviorIntervention) {
        this._behaviorIntervention = value;
        this.observableIntervention.next(value);
    }

    public observableIntervention = new Subject<BehaviorIntervention>();
    observableInterventionStream$ = this.observableIntervention.asObservable();

    public observableInterventionAttachmentRefresh = new Subject<InterventionAttachment[]>();
    observableInterventionAttachmentRefreshStream$ = this.observableInterventionAttachmentRefresh.asObservable();

    public observableAssociateInterventionPopup = new Subject<AssociateInterventionPopup>();
    observableAssociateInterventionPopupStream$ = this.observableAssociateInterventionPopup.asObservable();

    _filterParamIntervention: BehaviorInterventionsFilterParam;
    filterChangeIntervention = new EventEmitter<any>();

    set filterParamIntervention(filterParamIntervention: BehaviorInterventionsFilterParam) {
        this._filterParamIntervention = filterParamIntervention;
        this.filterChangeIntervention.emit();
    }

    get filterParamIntervention() {
        return this._filterParamIntervention;
    }
    private _behaviorLetterCurrentStep: number;
    public get behaviorLetterCurrentStep(): number {
        return this._behaviorLetterCurrentStep;
    }

    public set behaviorLetterCurrentStep(value: number) {
        this._behaviorLetterCurrentStep = value;
        this.observableBehaviorLetterCurrentStep.next(value);
    }

    public observableBehaviorLetterCurrentStep = new Subject<number>();
    observableBehaviorLetterCurrentStepStream$ = this.observableBehaviorLetterCurrentStep.asObservable();
    public generateLetter = false;
    public generateMailingLabels: GenerateMailingLabels = new GenerateMailingLabels();

    showActiveLookups(items: Lookup[], field: any) {
        if (!Array.isArray(field)) {
            return items.filter(o => o.DelStatus == false || o.Code == (!field ? '' : field));
        } else {
            return items.filter(o => o.DelStatus == false || field.find(f => f == o.Code));
        }
    }

    isFiltered(): boolean {
        return !!this.filterParam.eventDateFrom ||
            !!this.filterParam.eventDateTo ||
            !!this.filterParam.actionDateFrom ||
            !!this.filterParam.actionDateTo ||
            !!this.filterParam.incidentCode ||
            !!this.filterParam.actionCode ||
            !!this.filterParam.reportedToState ||
            !!this.filterParam.onlyShowSuspensions ||
            !!this.filterParam.offender ||
            !!this.filterParam.victim ||
            !!this.filterParam.location ||
            !!this.filterParam.comment ||
            !!this.filterParam.incidentApproveAction;
    }

    isFilteredIntervention(): boolean {
        return !!this.filterParamIntervention.startDateFrom ||
            !!this.filterParamIntervention.startDateTo ||
            !!this.filterParamIntervention.endDateFrom ||
            !!this.filterParamIntervention.endDateTo ||
            !!this.filterParamIntervention.nextMeetingDateFrom ||
            !!this.filterParamIntervention.nextMeetingDateTo ||
            !!this.filterParamIntervention.interventionist ||
            !!this.filterParamIntervention.refferedBy ||
            !!this.filterParamIntervention.refferedByOther ||
            !!this.filterParamIntervention.notes ||
            !!this.filterParamIntervention.status ||
            !!(
                this.filterParamIntervention.selectedReasons != null &&
                this.filterParamIntervention.selectedReasons.length > 0
            ) ||
            !!(
                this.filterParamIntervention.students != null &&
                this.filterParamIntervention.students.length > 0
            ) ||
            !!this.filterParamIntervention.enteredBy;
    }

    constructor(
        private http: HttpClient,
        private behaviorSharedService: BehaviorSharedService,
        private userService: UserService,
        private yearService: YearService,
        private reportService: ReportingService,
        private userPreferencesService: UserPreferencesService,
        private sharedService: SharedService
    ) {
        this._filterParam = new BehaviorEventsFilterParam();
        this._filterParamIntervention = new BehaviorInterventionsFilterParam();
        this.generalPreferences = this.userPreferencesService.generalPreferences;
    }

    // HTTP Calls
    public getBehaviorEventCount(yearId = this.yearService.defaultYear.Id, schoolId = this.yearService.defaultYear.SchoolID): Observable<number> {
        return this.http.get<number>(System.apiURL.Counselor + `GetBehaviorEventCount?yearId=${yearId}&schoolId=${schoolId}`);
    }

    public getBehaviorEvents(yearId: number, schoolId: number, disciplineEventId = 0, pageNumber = 0, pageSize = -1, calledFromCard = false , ShowAllSchoolsEntries = false): Observable<BehaviorEvent[]> {
        return this.http.get<BehaviorEvent[]>(System.apiURL.Counselor + `GetBehaviorEvents?yearId=${yearId}&schoolId=${schoolId}&disciplineEventId=${disciplineEventId}&pageNumber=${pageNumber}&pageSize=${pageSize}&calledFromCard=${calledFromCard}&ShowAllSchoolsEntries=${ShowAllSchoolsEntries}`);
    }
    public getInterventionLookups(interventionId: number, lookupType: string, yearId: number, schoolId: number): Observable<Lookup[]> {
        return this.http.get<Lookup[]>(System.apiURL.Counselor + `GetInterventionLookups?interventionId=${interventionId}&type=${lookupType}&yearId=${yearId}&schoolId=${schoolId}`);
    }

    public getBehaviorIncidents(eventId: number): Observable<BehaviorIncident[]> {
        return this.http.get<BehaviorIncident[]>(System.apiURL.Counselor + `GetBehaviorIncidents?eventId=${eventId}`);
    }

    public getEventAttachments(eventId: number): Observable<BehaviorAttachment[]> {
        return this.http.get<BehaviorAttachment[]>(System.apiURL.Counselor + `GetBehaviorEventAttachments?eventId=${eventId}`);
    }

    public getIncidentAttachments(eventId: number): Observable<BehaviorAttachment[]> {
        return this.http.get<BehaviorAttachment[]>(System.apiURL.Counselor + `GetBehaviorIncidentAttachments?incidentId=${eventId}`);
    }

    public getIncidentsByEvent(filter: BehaviorIncidentSearch): Observable<BehaviorIncidentLetter[]> {
        return this.http.post<BehaviorIncidentLetter[]>(System.apiURL.Counselor + 'GetIncidentsByEvent', filter);
    }

    public getBehaviorActions(eventId: number): Observable<BehaviorAction[]> {
        return this.http.get<BehaviorAction[]>(System.apiURL.Counselor + `GetBehaviorActions?eventId=${eventId}&yearId=${this.yearService.defaultYear.Id}&schoolId=${this.yearService.defaultYear.SchoolID}`);
    }

    public getBehaviorActionCodes(yearId: number, profileArea: string): Observable<BehaviorActionCode[]> {
        return this.http.get<BehaviorActionCode[]>(System.apiURL.Counselor + `GetBehaviorActionCodes?yearId=${yearId}&schoolId=${this.yearService.defaultYear.SchoolID}&profileArea=${profileArea}`);
    }

    public saveAttachment(attachment: BehaviorAttachment, attachmentType: string): Observable<number> {
        return this.http.post<number>(System.apiURL.Counselor + `SaveBehaviorAttachment?attachmentType=${attachmentType}`, attachment);
    }

    public disciplineAttendanceBulkInsertModify(attendance: BehaviorAction[], startDate: Date, endDate: Date, aYIdentifier: string, DA_ID: number): Observable<boolean> {
        const startDateFormatted = formatDate(startDate, 'MM/dd/yyyy', 'en-US');
        const endDateFormatted = formatDate(endDate, 'MM/dd/yyyy', 'en-US');
        return this.http.post<boolean>(System.apiURL.Counselor + `DisciplineAttendanceBulkInsertModify?startDate=${startDateFormatted}&endDate=${endDateFormatted}&aYIdentifier=${aYIdentifier}&DA_ID=${DA_ID}`, attendance);
    }

    public disciplineTeamAttendanceBulkInsertModify(attendance: BehaviorAction[], startDate: Date, endDate: Date, aYIdentifier: string, DA_ID: number): Observable<boolean> {
        const startDateFormatted = formatDate(startDate, 'MM/dd/yyyy', 'en-US');
        const endDateFormatted = formatDate(endDate, 'MM/dd/yyyy', 'en-US');
        return this.http.post<boolean>(System.apiURL.Counselor + `DisciplineTeamAttendanceBulkInsertModify?startDate=${startDateFormatted}&endDate=${endDateFormatted}&aYIdentifier=${aYIdentifier}&DA_ID=${DA_ID}`, attendance);
    }

    public saveBehaviorAction(action: BehaviorAction): Observable<BehaviorAction> {
        return this.http.post<BehaviorAction>(System.apiURL.Counselor + 'SaveBehaviorAction', action);
    }

    public getMaxFileSize(): Observable<number> {
        return this.http.get<number>(System.apiURL.Counselor + 'GetMaxFileSize');
    }

    public getStudentCalendar(studentId: number, yearId: number): Observable<ScheduleCalendar> {
        return this.http.get<ScheduleCalendar>(System.apiURL.Counselor + `GetScheduleCalendarByStudentId?studentId=${studentId}&yearId=${yearId}`);
    }

    public isOverlapActionDates(studentId: number, fromDate: string, toDate: string, actionId: number): Observable<boolean> {
        return this.http.get<boolean>(System.apiURL.Counselor + `IsOverlapActionDates?studentId=${studentId}&fromDate=${fromDate}&toDate=${toDate}&actionId=${actionId}`);
    }

    public isDisciplineCodeDetSusExpType(actionCode: string, yearId: number): Observable<boolean> {
        return this.http.get<boolean>(System.apiURL.Counselor + `IsDisciplineCodeDetSusExpType?actionCode=${actionCode}&yearId=${yearId}`);
    }

    public isDisciplineCodeSuspensionType(actionCode: string, ayIdentifier: string): Observable<boolean> {
        return this.http.get<boolean>(System.apiURL.Counselor + `IsDisciplineCodeSuspensionType?actionCode=${actionCode}&ayIdentifier=${ayIdentifier}`);
    }

    public getEndDateFromStartAndDuration(calendarId: number, startDate: string, duration: number, holidayIn: boolean): Observable<Date> {
        return this.http.get<Date>(System.apiURL.Counselor + `GetEndDateFromStartAndDuration?calendarId=${calendarId}&startDate=${startDate}&duration=${duration}&holidayIn=${holidayIn}`);
    }

    public getDurationFromStartAndEndDate(calendarId: number, startDate: string, endDate: string, holidayIn: boolean): Observable<number> {
        return this.http.get<number>(System.apiURL.Counselor + `GetDurationFromStartAndEndDate?calendarId=${calendarId}&startDate=${startDate}&endDate=${endDate}&holidayIn=${holidayIn}`);
    }

    public getReferralsByEventId(eventId: number, schoolId: number, yearId: number): Observable<DisciplineReferral[]> {
        return this.http.get<DisciplineReferral[]>(System.apiURL.Counselor + `GetDisciplineReferralsByEventId?eventId=${eventId}&schoolId=${schoolId}&yearId=${yearId}`);
    }

    public getAttendanceCodeLookup(isTeacher: boolean, schoolId: number, yearId: number): Observable<AttendanceCode[]> {
        return this.sharedService.getAttendanceCodeLookup(isTeacher, schoolId, yearId);
    }

    public getStudentScheduleforSuspensionAttendance(ayIdentifier: string, studentId: number, fromDate: Date, toDate: Date, DA_ID: number): Observable<BehaviorAction[]> {
        const startDate = formatDate(fromDate, 'MM/dd/yyyy', 'en-US');
        const endDate = formatDate(toDate, 'MM/dd/yyyy', 'en-US');
        return this.http.get<BehaviorAction[]>(System.apiURL.Counselor + `GetStudentScheduleforSuspensionAttendance?ayIdentifier=${ayIdentifier}&studentId=${studentId}&fromDate=${startDate}&toDate=${endDate}&DA_ID=${DA_ID}`);
    }

    public getStudentTeamSchedulebyDate(ayIdentifier: string, studentId: number, fromDate: Date, toDate: Date): Observable<BehaviorAction[]> {
        const startDate = formatDate(fromDate, 'MM/dd/yyyy', 'en-US');
        const endDate = formatDate(toDate, 'MM/dd/yyyy', 'en-US');
        return this.http.get<BehaviorAction[]>(System.apiURL.Counselor + `GetStudentTeamSchedulebyDate?ayIdentifier=${ayIdentifier}&studentId=${studentId}&fromDate=${startDate}&toDate=${endDate}`);
    }

    public createNonStudent(student: BehaviorStudent): Observable<BehaviorStudent> {
        return this.http.post<BehaviorStudent>(System.apiURL.Counselor + 'CreateNonStudent', student);
    }

    public deletNonStudent(student: BehaviorStudent): Observable<boolean> {
        return this.http.post<boolean>(System.apiURL.Counselor + 'DeleteNonStudent', student);
    }

    public getBehaviorPolicies(schoolId: number, yearId: number): Observable<BehaviorPolicies> {
        return this.http.get<BehaviorPolicies>(System.apiURL.Counselor + `GetBehaviorPolicies?schoolId=${schoolId}&yearId=${yearId}`);
    }

    public getBehaviorDaysServed(studentId: number, yearId: number, actionId: number, actionType: string, actionCodeType: string): Observable<number> {
        return this.http.get<number>(System.apiURL.Counselor + `GetBehaviorDaysServed?studentId=${studentId}&yearId=${yearId}&actionId=${actionId}&actionType=${actionType}&actionCodeType=${actionCodeType}`);
    }

    public getBehaviorInterventions(yearId: number, schoolId: number, interventionId: number = 0): Observable<BehaviorIntervention[]> {
        return this.http.get<BehaviorIntervention[]>(System.apiURL.Counselor + `GetBehaviorInterventions?yearId=${yearId}&schoolId=${schoolId}&interventionId=${interventionId}`);
    }

    public saveBehaviorIntervention(e: BehaviorIntervention): Observable<BehaviorIntervention> {
        return this.http.post<BehaviorIntervention>(System.apiURL.Counselor + 'SaveBehaviorIntervention', e);
    }

    public getBehaviorLetterTemplates(yearId: number, schoolId: number, templateId: number = 0): Observable<EFormTemplate[]> {
        return this.http.get<EFormTemplate[]>(System.apiURL.Counselor + `GetBehaviorLetterTemplates?yearId=${yearId}&schoolId=${schoolId}&templateId=${templateId}`);
    }

    public saveBehaviorLetterTemplate(blt: EFormTemplate): Observable<EFormTemplate> {
        return this.http.post<EFormTemplate>(System.apiURL.Counselor + 'SaveBehaviorLetterTemplate', blt);
    }

    public getBehaviorLetters(yearId: number, schoolId: number, DGL_ID: number = 0, templateId: number = 0, includeEForm: boolean = false, includePDF: boolean = false): Observable<BehaviorLetter[]> {
        return this.http.get<BehaviorLetter[]>(System.apiURL.Counselor + `GetBehaviorLetters?yearId=${yearId}&schoolId=${schoolId}&DGL_ID=${DGL_ID}&templateId=${templateId}&includeEForm=${includeEForm}&includePDF=${includePDF}`);
    }

    public saveBehaviorLetters(behaviorLetters: BehaviorLetter[]): Observable<any> {
        return this.http.post<any>(System.apiURL.Counselor + 'SaveBehaviorLetters', behaviorLetters);
    }

    public deleteBehaviorLetters(behaviorLetterIDs: number[]): Observable<any> {
        return this.http.post<any>(System.apiURL.Counselor + 'DeleteBehaviorLetters', behaviorLetterIDs);
    }

    public saveInterventionMeeting(meetings: InterventionMeeting[], interventionId: number): Observable<number> {
        return this.http.post<number>(System.apiURL.Counselor + `SaveInterventionMeeting?interventionId=${interventionId}`, meetings);
    }

    public saveInterventionAttachment(attachment: InterventionAttachment, attachmentType: string, userId: number): Observable<number> {
        return this.http.post<number>(System.apiURL.Counselor + `SaveInterventionAttachment?attachmentType=${attachmentType}&userId=${userId}`, attachment);
    }

    public saveContract(e: Contract): Observable<Contract> {
        return this.http.post<Contract>(System.apiURL.Counselor + 'SaveContract', e);
    }

    public saveAssociateIntervention(userId: number, csmis: CounselorStudentMeetingInterventions[]): Observable<boolean> {
        return this.http.post<boolean>(System.apiURL.Counselor + `SaveAssociateIntervention?userId=${userId}`, csmis);
    }

    public getAssociateInterventions(userId: number, ClId: number): Observable<CounselorStudentMeetingInterventions[]> {
        return this.http.get<CounselorStudentMeetingInterventions[]>(System.apiURL.Counselor + `GetAssociateInterventions?userId=${userId}&clId=${ClId}`);
    }

    public saveAssociateEvent(userId: number, deis: DisciplineEventIntervention[]): Observable<boolean> {
        return this.http.post<boolean>(System.apiURL.Counselor + `SaveAssociateEvent?userId=${userId}`, deis);
    }

    public saveCommunicaitonLogIntervention(cl: CommunicationLog, i: number, userId: number): Observable<boolean> {
        // NOTE: we copy to prevent other errors from propagating
        const copyLog = new CommunicationLog();
        Object.assign(copyLog, cl);
        copyLog.Reason = '';
        copyLog.InformOthers = '';
        return this.http.post<boolean>(System.apiURL.Counselor + `SaveCounselorStudentMeetingIntervention?interventionId=${i}&userId=${userId}`, copyLog);
    }

    public saveBehaviorIncident(incident: BehaviorIncident): Observable<BehaviorIncident> {
        return this.behaviorSharedService.saveBehaviorIncident(incident);
    }

    getIncidentDescription(incidentCode: string, getById: boolean, truncate: number = 0): string {
        let incidentLookup: Lookup;
        if (getById) {
            incidentLookup = this.incidentCodes.find(function (i) {
                return i.Id.toString() == incidentCode.toString();
            });
        } else {
            incidentLookup = this.incidentCodes.find(function (i) {
                return i.Code == incidentCode;
            });
        }
        if (incidentLookup != null) {
            if (truncate > 0 && incidentLookup.CodeDescription.length > truncate) {
                return incidentLookup.Code + ' - ' + incidentLookup.CodeDescription.substring(0, truncate) + '...';
            }
            return incidentLookup.Code + ' - ' + incidentLookup.CodeDescription;
        } else {
            return ' ';
        }
    }

    public generateNewIncident(): BehaviorIncident {
        let id = Math.min.apply(null, this.behaviorEvent.Incidents.map(i => i.Id));
        if (id >= 0) {
            id = -1;
        } else {
            id = id - 1;
        }
        const newIncident = new BehaviorIncident();
        newIncident.Id = id;
        newIncident.EventId = this.behaviorEvent.Id;
        newIncident.InvolvementType = 'Offender';
        newIncident.AlcoholRelated = this.behaviorEvent.DefaultAlcoholRelated;
        newIncident.DrugRelated = this.behaviorEvent.DefaultDrugRelated;
        newIncident.GangRelated = this.behaviorEvent.DefaultGangRelated;
        newIncident.HateCrimeRelated = this.behaviorEvent.DefaultHateRelated;
        newIncident.WeaponRelated = this.behaviorEvent.DefaultWeaponRelated;
        newIncident.IncidentCode = this.behaviorEvent.DefaultIncidentCodeId;
        newIncident.ReportedToPolice = this.behaviorEvent.DefaultReportedToPolice;
        newIncident.DisciplineIncidentSubCodesId = this.behaviorEvent.DisciplineIncidentSubCodeId;
        newIncident.AddedOn = new Date();
        newIncident.AddedBy = this.userService.currentUser.Id;
        const selectedCode = this.incidentCodes.find(c => c.Code == newIncident.IncidentCode);
        if (selectedCode != null) {
            newIncident.DCID = parseInt(selectedCode.Id, 10);
        }
        return newIncident;
    }

    refreshAttachmentGrid() {
        if (this.attachmentsComponent != null) {
            this.attachmentsComponent.refreshGrid();
        }
    }

    uniqueStudents(studentId: number): string {
        // Returning the unique students
        if (studentId > 0) {
            this.behaviorUniqueStudents = this.behaviorEvent.Students.filter(s => s.Id == studentId && s.Deleted == false)[0];
            let studentNumber = '';
            if (this.behaviorUniqueStudents != undefined) {
                studentNumber += ' ' + this.behaviorUniqueStudents.StudentNumber;
            }
            return studentNumber;
        }
    }

    removeElement(array: any[], element: any) {
        const index: number = array.indexOf(element);
        if (index != -1) {
            array.splice(index, 1);
        }
    }

    public disciplineReferralIncidentLookup(yearId: number): Observable<Lookup[]> {
        return this.behaviorSharedService.disciplineReferralIncidentLookup(yearId, 'Discipline');
    }

    public saveBehaviorEvent(e: BehaviorEvent): Observable<BehaviorEvent> {
        return this.behaviorSharedService.saveBehaviorEvent(e);
    }

    public getDisciplineLocations(schoolId: number): Observable<Lookup[]> {
        return this.behaviorSharedService.getDisciplineReferralPlacesLookup(schoolId);
    }

    public getDisciplineReferralLookups(lookupType: string, yearId: number, schoolId: number): Observable<Lookup[]> {
        return this.behaviorSharedService.getDisciplineReferralLookups(lookupType, yearId, schoolId);
    }

    public getInterventionById(yearId: number, schoolId: number, interventionId: number) {
        this.getBehaviorInterventions(yearId, schoolId, interventionId).subscribe((interventions: BehaviorIntervention[]) => {
            this.behaviorIntervention = _.cloneDeep(interventions[0]);
            if (this.behaviorIntervention.NextMeetingDate && this.getCellClass(this.behaviorIntervention.NextMeetingDate)) {
                this.behaviorIntervention.nextMValue = true;
            }
        });
    }

    getCellClass(value) {
        if (value != null) {
            return (moment(moment(value, 'YYYY-MM-DDTHH:mm:ss').format('MM/DD/YY'), 'MM/DD/YY').isBefore(moment(new Date(), 'YYYY-MM-DDTHH:mm:ss').format('MM/DD/YY')) ? true : false);
        }
    }

    refresInterventionAttachmentGrid(attachment: InterventionAttachment[]) {
        this.observableInterventionAttachmentRefresh.next(attachment);
    }

    openAssociateInterventionPopup(aip: AssociateInterventionPopup) {
        this.observableAssociateInterventionPopup.next(aip);
    }

    generateMailingAddresses(studentIds: number[]) {
        if (studentIds && studentIds.length > 0) {
            let xml = '';
            xml += '<NewDataSet>';
            studentIds.forEach(studentId => {
                xml += '<Table1>';
                xml += '<Student_ID>' + studentId + '</Student_ID>';
                xml += '</Table1>';
            });
            xml += '</NewDataSet>';

            const studentIdParameter: string = '@p_Student_Id=\'' + xml + '\'';
            const addressTypeParameter = '@AddressType=\'Default\'';
            const queryString: string = studentIdParameter + ', ' + addressTypeParameter;

            this.reportService.runManualReport(30075, queryString).subscribe(results => {
                this.runReportByType('PDF', results, 'MailingLabels');
            });
        }
    }

    runReportByType(reportType: string, results, name: string): void {

        try {

            const byteCharacters: string = atob(results);
            const byteNumbers = new Array(byteCharacters.length);

            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }

            const byteArray: Uint8Array = new Uint8Array(byteNumbers);

            const fileExtension = '.pdf';
            const mimeType = 'application/pdf';

            let FileAsBlob: Blob;

            FileAsBlob = new Blob([byteArray], { type: 'application/pdf' });

            //  For other browsers:
            //  Create a link pointing to the ObjectURL containing the blob.

            const reportNameWithoutSpaces: string = name.replace(/ /g, '');

            const data = window.URL.createObjectURL(FileAsBlob);
            const link = document.createElement('a');
            link.href = data;
            link.download = reportNameWithoutSpaces + fileExtension;
            link.click();

            //  For Firefox it is necessary to delay revoking the ObjectURL
            setTimeout(this.revokeObjectURL(data), 100);

        } catch {
        }

    } //  end runReportPDF

    //  For Firefox it is necessary to delay revoking the ObjectURL
    revokeObjectURL(data): any {
        window.URL.revokeObjectURL(data);
    }

    // V9 Only
    generateV9MailingAddresses(generateMailingLabels: GenerateMailingLabels, reportName: string, reportType: number): Observable<any> {

        this.generateLetter = false;
        this.parameters = [];
        this.param = [];
        let Ids = '';
        Ids = generateMailingLabels.studentIds.join(',');
        if (generateMailingLabels.householdParents === false && generateMailingLabels.nonresidentParents === false) {
            generateMailingLabels.householdParents = true;
        }
        this.param.push({ ParamName: 'lngSiteYearId', ParamStringValue: this.yearService.defaultYear.SiteYearId });
        this.param.push({ ParamName: 'strStudentSelectionStatus', ParamStringValue: 'Custom' });
        this.param.push({ ParamName: 'strStudentIds', ParamStringValue: Ids });
        this.param.push({ ParamName: 'blnPrimaryParentsAddress', ParamStringValue: generateMailingLabels.householdParents });
        this.param.push({ ParamName: 'blnAlternateParentsAddress', ParamStringValue: generateMailingLabels.nonresidentParents });
        this.param.push({ ParamName: 'blnAlternateParAddrOnlyIfRequested', ParamStringValue: generateMailingLabels.onlyIfRequested });
        this.param.push({ ParamName: 'blnParentsCombinedName', ParamStringValue: true });
        this.param.push({ ParamName: 'blnParent1NameOnly', ParamStringValue: false });
        this.param.push({ ParamName: 'blnStudentNameOnly', ParamStringValue: false });
        this.param.push({ ParamName: 'blnIsGenericParentsGreeting', ParamStringValue: false });
        this.param.push({ ParamName: 'strGenericParentsGreeting', ParamStringValue: '' });
        this.param.push({ ParamName: 'blnGenericParentsGreetingIncludeName', ParamStringValue: false });

        this.param.push({ ParamName: 'lngLinePerPage', ParamStringValue: 10 });
        this.param.push({ ParamName: 'lngColumnsPerPage', ParamStringValue: 3 });
        this.param.push({ ParamName: 'lngStartDown', ParamStringValue: 1 });
        this.param.push({ ParamName: 'lngStartAcross', ParamStringValue: 1 });
        this.param.push({ ParamName: 'blnCustomInformation', ParamStringValue: false });
        this.param.push({ ParamName: 'strBody1', ParamStringValue: '' });
        this.param.push({ ParamName: 'blnReverseName', ParamStringValue: true });
        this.param.push({ ParamName: 'blnAutoSortZipCode', ParamStringValue: false });
        this.param.push({ ParamName: 'lngPrintCopies', ParamStringValue: 1 });
        this.param.push({ ParamName: 'blnPrintDulicateAddress', ParamStringValue: true });
        this.param.push({ ParamName: 'blnAllCaps', ParamStringValue: true });

        this.parameters.push(JSON.stringify(this.param));
        const studentAttachment: StudentAttachment = {
            DocumentId: 0,
            DocumentName: reportName,
            DocumentBase64: '',
            DocumentMimeType: '',
            DocumentModuleName: '',
            ReportParameters: this.parameters,
            ReportType: reportType
        };
        window.localStorage.setItem('studentAttachment', JSON.stringify(studentAttachment));
        const win = window.open(System.baseUrl + 'studentattachment', '_blank');
        win.focus();
        const timer = setInterval(() => {
            if (!timer) {
                clearInterval(timer);
            }
            if (win.closed) {
                // using for reprint lables only for print only
                // if (this.behaviorLetterCurrentStep < 5 && generateMailingLabels.printOnly) {
                //     this.behaviorLetterCurrentStep = this.behaviorLetterCurrentStep + 1;
                // }
                // else if (this.behaviorLetterCurrentStep < 6 && generateMailingLabels.printOnly == false) {
                //     this.behaviorLetterCurrentStep = this.behaviorLetterCurrentStep + 1;
                // }
                clearInterval(timer);
                win.focus();
            }
        }, 1000);
        return this.observableBehaviorLetterCurrentStepStream$;
    }

    public getEmailAddressessByStudentIds(studentIds: number[], studentStatus: string, reverseName = 0): Observable<BehaviorLetterEmailAddress[]> {
        const siteYearId = this.yearService.defaultYear.SiteYearId;
        return this.http.post<BehaviorLetterEmailAddress[]>(System.apiURL.Counselor + `GetEmailAddressessByStudentIds?studentStatus=${studentStatus}&siteYearId=${siteYearId}&reverseName=${reverseName}`, studentIds);
    }
}
